var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgViju = function SvgViju(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#viju_svg__a)",
    d: "m4.648 13.135 2.588-8.701h2.442L6.006 15H4.482zM2.666 4.434l2.637 8.74L5.43 15H3.906L.215 4.434zm10.786 0V15H11.09V4.434zm-2.52-2.774q0-.537.352-.889.362-.36.996-.36.626 0 .987.36.36.352.361.89 0 .526-.361.878-.362.351-.986.352-.636 0-.997-.352a1.2 1.2 0 0 1-.351-.879m5.016 2.774h2.363v11.484q0 1.084-.371 1.826a2.5 2.5 0 0 1-1.094 1.133q-.722.39-1.767.39-.313 0-.645-.048a5 5 0 0 1-.644-.117l.01-1.836q.204.039.439.058.225.03.43.03.42 0 .702-.147a.95.95 0 0 0 .43-.459q.147-.312.147-.83zm-.205-2.774q0-.537.36-.889.362-.36.987-.36.634 0 .987.36.36.352.36.89 0 .526-.36.878-.352.351-.987.352-.624 0-.986-.352a1.18 1.18 0 0 1-.361-.879m11.264 10.85V4.434h2.364V15h-2.227zm.332-2.197.792-.02q0 1.065-.235 1.963a4.6 4.6 0 0 1-.723 1.553 3.4 3.4 0 0 1-1.25 1.025q-.76.36-1.826.361a4.3 4.3 0 0 1-1.416-.224q-.644-.225-1.113-.694-.46-.469-.713-1.22-.255-.752-.254-1.797V4.434h2.354v6.845q0 .577.136.967.137.382.371.615.235.235.547.332.313.099.664.098 1.006 0 1.583-.39a2.16 2.16 0 0 0 .83-1.075q.254-.674.254-1.514"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "viju_svg__a",
    x1: 0,
    x2: 31,
    y1: 8,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#580EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6701A9"
  })))));
};
export default SvgViju;